<template>
  <div class="table_box">
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="version" label="版本号" width="120"></el-table-column>
      <el-table-column prop="image" label="图片" width="200">
        <template slot-scope="scope">
          <img :src="scope.row.image" style="max-width: 100px; max-height: 60px" />
        </template>
      </el-table-column>
      <el-table-column prop="description" label="更新说明" min-width="250">
        <template slot-scope="scope">
          <div style="white-space: pre-wrap; word-break: break-word">
            {{ scope.row.description }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
      <el-table-column prop="updated_at" label="更新时间" width="180"></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="handleEdit(scope.row)"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "AppVersionTable",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleEdit(row) {
      this.$emit("edit", row);
    },
    handleDelete(row) {
      this.$emit("delete", row);
    },
  },
};
</script>

<style scoped>
.table_box {
  width: 100%;
}
</style>
